module.exports = __webpack_public_path__ + "static/img/装饰8.6dac654.svg";


//////////////////
// WEBPACK FOOTER
// ./src/views/decorativePainting/imgs/装饰8.svg
// module id = EmR7
// module chunks = 2